<div class="upload-wrapper" [ngClass]="{
    dragover: isDraggingFile,
    loading: isLoadingFile,
    loadingError: isLoadingFileError,
    isTouchOnlyPlatform: browsersniffer.isTouchDevice && browsersniffer.isMobileOS 
  }">

  <!-- loading -->
  @if (isLoadingFile&&!isLoadingFileError) {
  <div>
    <div class="spinner-wrapper flex-container container-centered ">
      <mat-spinner color="accent" [diameter]="25"></mat-spinner>
    </div>
    <div>
      <br>
      {{ loadingText | translate }}
    </div>
  </div>
  }

  <!-- error -->
  @if (isLoadingFileError) {
  <div>
    <div><mat-icon class="uploader-icon">sentiment_dissatisfied</mat-icon></div>
    {{ loadingFailedText | translate : { supportedExtensions: formatList(allowedExtensions), max:
    getMaxUploadSizePerFile()} }}
    <div><button (click)="back()" mat-button class="back-tip"><mat-icon aria-label="map">arrow_back_ios</mat-icon>{{ "general.back" | translate }}</button></div>
  </div>
  }

  <!-- uploader box -->
  @if (!isLoadingFile&&!isLoadingFileError) {
  <div>
    @if (!browsersniffer.isTouchDevice && !browsersniffer.isMobileOS) {
    <div><mat-icon class="uploader-icon">file_upload</mat-icon></div>
    <span>
      {{ extraInfoWithDropFunctionText | translate }}
    </span>
    }
    <!-- {{ browsersniffer.isTouchDevice && browsersniffer.isMobileOS ? "": (extraInfoWithDropFunctionText | translate)}} -->
    <!-- capture  -->
    <!-- <button matIconButton type="button" (click)="sjappi()">
      <mat-icon class="uploader-icon">photo_camera</mat-icon>
    </button> -->
    <div class="flex-container">

      @if ((browsersniffer.isTouchDevice && browsersniffer.isMobileOS && capturesEnabled)) {
      <label class="upload-button file-upload-button">
        <div class="upload-button-flex-container">
          @if (useCapacitorPlugin(true)) {
            <!--
            <button matIconButton type="button" #inputCaptureFileElement
            (click)="takePicture()" [disabled]="isLoadingFile"><mat-icon class="uploader-icon">photo_camera</mat-icon></button>
            -->
            <input #inputCaptureFileElement type="button" class="nativeCapture"
            name="inputCaptureFileElement" (click)="takePicture()" [disabled]="isLoadingFile" />
            <mat-icon class="uploader-icon">photo_camera</mat-icon>
          } @else {  
          <input #inputCaptureFileElement (change)="onCaptureImport()" capture="environment" type="file"
            name="inputCaptureFileElement" [attr.multiple]="multiple ? multiple : null"
            [attr.accept]="accept ? accept : null" [disabled]="isLoadingFile" />
            <mat-icon class="uploader-icon">photo_camera</mat-icon>
          }
          <span>
            Camera...
          </span>
        </div>
      </label>
      }
      <!-- file selection -->
      <label class="upload-button file-upload-button">
        <div class="upload-button-flex-container">
          <!-- matInput -->
          <input #inputSelectFileElement (change)="onSelectImport()" type="file" name="inputFileElement"
            [attr.multiple]="multiple ? multiple : null" [attr.accept]="accept ? accept : null"
            [disabled]="isLoadingFile" />
          @if ((browsersniffer.isTouchDevice && browsersniffer.isMobileOS && capturesEnabled)) {
          <mat-icon class="uploader-icon">drive_folder_upload
          </mat-icon>
          }
          <span>
            {{ fileButtonText | translate }}
          </span>
        </div>
      </label>
    </div>
  </div>
  }
</div>

<!-- uploaded files list  -->
@if (showFileList && getUploaderFiles().length > 0) {
<mat-list>
  <div mat-subheader>{{ "file-uploader.imported-files" | translate }}</div>
  @for (file of getUploaderFiles(); track file) {
  <mat-list-item [ngClass]="{'file-contains-errors': file.errors && file.errors.length > 0}" @fade>
    <div mat-line>{{ file.file.name }}</div>
    @for (error of file.errors; track error) {
    <div mat-line>
      <mat-error class="error-line">
        <mat-icon class="small-icon" style="color: red;">error_outline</mat-icon><span>{{ error | translate : {
          supportedExtensions: formatList(allowedExtensions), max: getMaxUploadSizePerFile()} }}</span>
      </mat-error>
    </div>
    }
    <div class="remove-file-btn" (click)="removeFromImportedFiles(file)">
      <mat-icon>close</mat-icon>
    </div>
  </mat-list-item>
  }
  <mat-action-list style="text-align: end;">
    <button mat-button (click)="clearFileList()" type="button" class="error-button action-list-item">
      <mat-icon>clear</mat-icon>
      {{ "file-uploader.clear" | translate }}
    </button>
  </mat-action-list>
</mat-list>
}